import React from "react";
import MarketOverviewTable from "../MarketOverviewTable";
import { useMarketOverviewData } from "../../../context/MarketOverviewContext";
import { DEFAULT_CATALYSTS } from "../../../constants/sections";

const CryptoTab = () => {
    const { rows } = useMarketOverviewData();
    const data = rows.filter(row => (row.category || row.Category) === "Crypto");
    const CRYPTO_ORDER = ["BTCUSD", "ETHUSD"];
    return <MarketOverviewTable data={data} title="Crypto Analysis" defaultRowData={{ Category: "Crypto" }} defaultCatalysts={DEFAULT_CATALYSTS.Crypto} customSortOrder={CRYPTO_ORDER} />;
};

export default CryptoTab;
